var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoUserSponsorshipWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 99.531,
    height: 98.408,
    viewBox: "0 0 99.531 98.408",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4347",
    "data-name": "Grupo 4347",
    transform: "translate(-311 -462)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4331",
    "data-name": "Grupo 4331"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7389",
    "data-name": "Trazado 7389",
    d: "M66.5,23.926H10.512a.926.926,0,0,1-.891-.68.911.911,0,0,1,.442-1.023L38.054,6.69a.923.923,0,0,1,.9,0L66.943,22.223a.908.908,0,0,1-.447,1.7M14.033,22.1h48.95L38.514,8.52Z",
    transform: "translate(322.805 470.404)",
    fill: "#ffffff",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7390",
    "data-name": "Trazado 7390",
    d: "M66.492,19.5H10.508a.912.912,0,0,1-.912-.912v-3.8a.913.913,0,0,1,1.827,0v2.888H65.57V14.785a.913.913,0,0,1,1.827,0v3.8a.912.912,0,0,1-.912.912Z",
    transform: "translate(322.808 478.626)",
    fill: "#ffffff",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7391",
    "data-name": "Trazado 7391",
    d: "M20.153,21.786H14.31a4.982,4.982,0,0,1-4.716-5.205.826.826,0,1,1,1.642-.183.876.876,0,0,1,0,.183A3.244,3.244,0,0,0,14.3,19.966h5.845a3.237,3.237,0,0,0,3.064-3.385.827.827,0,1,1,1.644-.183.876.876,0,0,1,0,.183,4.984,4.984,0,0,1-4.7,5.205",
    transform: "translate(322.8 480.64)",
    fill: "#ffffff",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7392",
    "data-name": "Trazado 7392",
    d: "M40.164,21.789H34.321A4.982,4.982,0,0,1,29.6,16.583a.826.826,0,0,1,.736-.912l.006,0a.831.831,0,0,1,.912.74l0,.006a1.025,1.025,0,0,1,0,.162,3.236,3.236,0,0,0,3.066,3.385h5.843a3.242,3.242,0,0,0,3.066-3.385.827.827,0,0,1,1.644-.183,1.313,1.313,0,0,1,0,.183,4.984,4.984,0,0,1-4.714,5.212",
    transform: "translate(345.337 480.638)",
    fill: "#ffffff",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7393",
    "data-name": "Trazado 7393",
    d: "M24.04,37.357a.87.87,0,0,1-.823-.912,3.241,3.241,0,0,0-3.066-3.387H14.308a3.242,3.242,0,0,0-3.066,3.387.827.827,0,0,1-1.644.181.855.855,0,0,1,0-.181,4.987,4.987,0,0,1,4.716-5.21h5.843a4.99,4.99,0,0,1,4.718,5.21.871.871,0,0,1-.825.912H24.04",
    transform: "translate(322.804 498.181)",
    fill: "#ffffff",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7394",
    "data-name": "Trazado 7394",
    d: "M44.057,37.352a.869.869,0,0,1-.823-.91l0,0a3.245,3.245,0,0,0-3.066-3.387H34.324A3.239,3.239,0,0,0,31.26,36.44a.834.834,0,0,1-.742.912h0a.829.829,0,0,1-.912-.736v-.009a1.025,1.025,0,0,1,0-.162,4.984,4.984,0,0,1,4.72-5.207h5.833a4.986,4.986,0,0,1,4.716,5.207.869.869,0,0,1-.814.906",
    transform: "translate(345.336 498.186)",
    fill: "#ffffff",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7395",
    "data-name": "Trazado 7395",
    d: "M12.249,48.323a.868.868,0,0,1-.821-.912V18.6a.826.826,0,1,1,1.642-.183.876.876,0,0,1,0,.183V47.411a.865.865,0,0,1-.819.912h0",
    transform: "translate(324.866 482.92)",
    fill: "#ffffff",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7396",
    "data-name": "Trazado 7396",
    d: "M35.005,48.323a.871.871,0,0,1-.823-.912V18.6a.827.827,0,0,1,1.644-.183.876.876,0,0,1,0,.183V47.411a.868.868,0,0,1-.821.912",
    transform: "translate(350.495 482.92)",
    fill: "#ffffff",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7397",
    "data-name": "Trazado 7397",
    d: "M15.53,48.323a.864.864,0,0,1-.823-.906V18.6a.827.827,0,0,1,1.644-.183.876.876,0,0,1,0,.183V47.41a.872.872,0,0,1-.821.912",
    transform: "translate(328.559 482.92)",
    fill: "#ffffff",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7398",
    "data-name": "Trazado 7398",
    d: "M31.728,48.323a.87.87,0,0,1-.825-.91V18.6a.827.827,0,0,1,1.644-.183.658.658,0,0,1,0,.183V47.411a.867.867,0,0,1-.819.912",
    transform: "translate(346.801 482.92)",
    fill: "#ffffff",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7399",
    "data-name": "Trazado 7399",
    d: "M66.492,39.143H10.508a.912.912,0,0,1-.912-.914V34.167a.912.912,0,0,1,.912-.912H66.492a.914.914,0,0,1,.914.912v4.061a.914.914,0,0,1-.914.914M11.427,37.316H65.576V35.075H11.427Z",
    transform: "translate(322.808 500.456)",
    fill: "#ffffff",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1719",
    "data-name": "Rect\\xE1ngulo 1719",
    width: 97.531,
    height: 96.408,
    transform: "translate(312 463)",
    fill: "none",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoUserSponsorshipWhite);
export default __webpack_public_path__ + "static/media/logo-user-sponsorship-white.a63eb46cb570f177a03440420137d166.svg";
export { ForwardRef as ReactComponent };